<div class="catalog-product-list">
  <ng-container *ngIf="productsAreLoading; else list">
    <ng-container *ngIf="isMobile">
      <div fxLayout="column">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 150, 'margin-bottom.px': 8, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 150, 'margin-bottom.px': 8, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 150, 'margin-bottom.px': 8, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 150, 'margin-bottom.px': 8, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          [theme]="{ 'height.px': 150, 'margin-bottom.px': 8, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
      </div>
    </ng-container>
    <ng-container *ngIf="isTablet">
      <div fxLayout="column">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          count="3"
          [theme]="{ 'height.px': 305, 'width.px': 230, 'margin.px': 4, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
          count="3"
          [theme]="{ 'height.px': 305, 'width.px': 230, 'margin.px': 4, 'background-color': '#FFFFFF' }"
        ></ngx-skeleton-loader>
      </div>
    </ng-container>
    <ng-container *ngIf="isDesktop">
      <div fxLayout="row" class="loader__desktop">
        <div fxLayout="column">
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
            count="4"
            [theme]="{ 'height.px': 380, 'width.px': 260, 'margin.px': 8, 'background-color': '#FFFFFF' }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            appearance="line"
            animation="progress"
            count="4"
            [theme]="{ 'height.px': 380, 'width.px': 260, 'margin.px': 8, 'background-color': '#FFFFFF' }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #list>
    <app-products-grid
      *ngIf="products !== null"
      [products]="products"
      [page]="page"
      [isDesktop]="isDesktop"
      [isMobile]="isMobile"
      [isCustomPLPPage]="isCustomPLPPage"
      [testId]="'PRODUCT_CATALOG.PRODUCT_LIST'"
      (productClicked)="onProductClick($event.product, $event.priceType, $event.index)"
      (productVisibilityChange)="onProductVisibility($event.isVisible, $event.index)"
      (indexPower10ProductVisible)="onIndexPower10ProductVisible($event)">
    </app-products-grid>
  </ng-template>
</div>
